import React from 'react';
import { OperaWindow } from './OperaWindow';
import type { Bed, Room } from '../lib/api';

interface Props {
  bed: Bed;
  room: Room;
  onChoose: (action: 'reserve' | 'block') => void;
  onClose: () => void;
}

/**
 * Small picker shown when reception clicks a free bed.
 * Asks "what do you want to do?" — reserve it, or block it for maintenance/etc.
 */
export function FreeBedChoiceModal({ bed, room, onChoose, onClose }: Props) {
  const bedDesc = room.displayName
    ? `Room ${room.number} (${room.displayName}) — ${bed.label}`
    : `Room ${room.number} — ${bed.label}`;

  return (
    <OperaWindow
      title="BED ACTION"
      status={bedDesc.toUpperCase()}
      onClose={onClose}
      size="compact"
      sideButtons={[
        { label: 'Close', onClick: onClose },
      ]}
    >
      <div className="choice-prompt">
        What would you like to do with this bed?
      </div>
      <div className="choice-buttons">
        <button className="choice-btn primary" onClick={() => onChoose('reserve')}>
          <div className="choice-btn-title">📝 New Accommodation Booking</div>
          <div className="choice-btn-sub">Book a guest into this bed</div>
        </button>
        <button className="choice-btn" onClick={() => onChoose('block')}>
          <div className="choice-btn-title">🔒 Block this Bed</div>
          <div className="choice-btn-sub">Maintenance, deep clean, hold, or out of order</div>
        </button>
      </div>
    </OperaWindow>
  );
}
